import React, { Component } from 'react';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import { bindActionCreators } from 'redux';
import { InscriptionPrelevement, obtenirProprietaire, telechargerFichier } from '../../../App_Code/API';
import { mapStateToPropsWrapper, verificationProps } from '../../CaptureErreurs';
import * as ProAct from '../../../Actions/ProActions';
import CardCoordonnees from '../CardCoordonnees';
import * as HttpStatus from '../../../App_Data/HttpStatus';
import LigneAdresse from '../../Adresse';
import Card from '../../Card';
import CardMandatEnCours from './CardMandatEnCours';
import FormSaisieRIB from './FormSaisieRIB';
import creationProcedureSignature from './FormProcedureSignature';

const Etape3Prl = ({
    Adresse, procedureSignature, idNouveauMandat, SignElecOk, classbtn3,
}) => (
    <div className="row justify-content-center">
        {!SignElecOk ?
            <div className="col-10">
                <Card className="alert-primary h-100">
                    <div className="text-center">
                        <p>Téléchargez, imprimez, datez, signez et envoyez votre mandat à l’adresse suivante :</p>
                        <LigneAdresse className="justify-content-center text-left" {...Adresse} />
                        <button className={`${classbtn3} w-75 mt-2`} onClick={() => { idNouveauMandat ? window.open(telechargerFichier(idNouveauMandat), '_blank') : null; }}>
                            <i className="fa fas fa-download" />
                            <span> Télécharger</span>
                        </button>
                    </div>
                </Card>
            </div>
            :
            <div className="col-12 row">
                <div className="col-12 col-md-7">
                    <Card className="alert-primary h-100" classCard="d-flex flex-column">
                        <span className="font-weight-bold text-center">Signature électronique</span>
                        <div className="text-center mt-auto">
                            <p>Signez votre mandat sans avoir à l’imprimer ni à l’envoyer.<br /><strong>Prise en compte immédiate</strong>.</p>
                        </div>
                        <button className={`${classbtn3} mt-auto w-100`} onClick={() => { procedureSignature(); }}>
                            <i className="fas fa-file-signature" />
                            <span> Accéder à la signature</span>
                        </button>
                    </Card>
                </div>
                <div className="d-flex align-items-center justify-content-center col-12 col-md-1 mt-2 mb-2">
                    <span className="badge badge-pill badge-primary align-middle">OU</span>
                </div>
                <div className="col-12 col-md-4">
                    <Card className="alert-primary alert-secondary h-100" classCard="d-flex flex-column ">
                        <span className="font-weight-bold text-center">Signature manuscrite </span>
                        <div className="text-center mt-2">
                            <p>Téléchargez, imprimez, datez, signez et envoyez votre mandat à :</p>
                            <LigneAdresse className="justify-content-center text-left" {...Adresse} />
                        </div>
                        <button className={`${classbtn3} mt-auto w-100`} onClick={() => { idNouveauMandat ? window.open(telechargerFichier(idNouveauMandat), '_blank') : null; }}>
                            <i className="fa fas fa-download" />
                            <span> Télécharger</span>
                        </button>
                    </Card>
                </div>
            </div>
        }
    </div>
);

const FormulaireIBAN = ({
    AutoMensuel, AutoExigibilite, state, ChangeModePrelevement, onSubmit, ModifState, Ind, creationProcedureSignature, idNouveauMandat, SignElecOk, classbtn2, classbtn3,
}) => (
    <Card
        Titre={
            state.TypePrelevementChoisi === 'Automatique'
                ? 'Inscription au prélèvement automatique'
                : 'Inscription au prélèvement à la demande'
        }
        Info={
            state.TypePrelevementChoisi === 'Automatique'
                ? "Avec ce mode de paiement, vous bénéficiez d'un paiement automatique et ne risquez pas l'oubli. Avec chaque appel de fonds, vous recevrez l'échéancier prévisionnel de prélèvement."
                : "Aucun prélèvement ne sera effectué sans votre demande expresse. Avec ce mode de paiement, vous bénéficiez d'un accès permanent à un paiement en ligne et , contrairement au prélèvement automatique, vous gardez le contrôle sur l'émission de chaque ordre de prélèvement. Pensez toutefois à actionner le paiement après notifications de vos échéances."
        }
    >
        <h5 className="text-muted mt-3"><span className="badge badge-pill badge-primary">1</span> Saisissez vos codes IBAN et BIC</h5 >
        <div className="ml-5">
            <FormSaisieRIB ChangeState={ModifState} State={state} />
            <div className="form-inline mt-3 justify-content-center" hidden={state.TypePrelevementChoisi === 'Manuelle'}>
                <div className="form-group mr-5 ml-5  custom-control custom-radio" hidden={!AutoMensuel}>
                    <input
                        className="custom-control-input"
                        id="rbTypePrelevement2"
                        name="ModePrelevement"
                        type="radio"
                        checked={state.ModePrelevement === '2'}
                        value={2}
                        onChange={ChangeModePrelevement}
                    />
                    <label className="custom-control-label" htmlFor="rbTypePrelevement2">
                        Automatique mensualisé
                    </label>
                </div>
                <div className="form-group mr-5 ml-5 custom-control custom-radio" hidden={!AutoExigibilite}>
                    <input
                        className="custom-control-input"
                        id="rbTypePrelevement3"
                        name="ModePrelevement"
                        type="radio"
                        checked={state.ModePrelevement === '1'}
                        value={1}
                        onChange={ChangeModePrelevement}
                    />
                    <label className="custom-control-label" htmlFor="rbTypePrelevement3">
                        Automatique à l&apos;exigibilité
                    </label>
                </div>
            </div>
        </div>

        <h5 className="text-muted mt-5"><span className="badge badge-pill badge-primary">2</span> Générez votre mandat</h5 >
        <div className="d-flex justify-content-center mt-3">
            <button id="GenereMandat" className={classbtn2} type="submit" onClick={onSubmit}>
                <i className="fa fas fa-plus" />
                <span> Générer</span>
            </button>
        </div>

        <h5 className="text-muted mt-5"><span className="badge badge-pill badge-primary">3</span> Signez {SignElecOk ? ' ' : ' et envoyez'} votre mandat</h5 >
        <Etape3Prl Adresse={Ind.Adresse} procedureSignature={creationProcedureSignature} idNouveauMandat={idNouveauMandat} SignElecOk={SignElecOk} classbtn3={classbtn3} />
    </Card>
);

class PageSaisieIBAN extends Component {
    constructor(props) {
        super(props);
        this.state = {
            IBAN: '',
            BIC: '',
            ModePrelevement: props.ModePrl.ModeDefaut.toString(),
            TypePrelevementChoisi: '',
            idNouveauMandat: false,
        };

        this.handleChangePrelevement = this.ChangeTypePrelevement.bind(this);
        this.procedureSignature = this.creationProcedureSignature.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount() {
        // Mise a jour du pro dès qu'on arrive sur la page
        obtenirProprietaire().then((pro) => {
            this.props.actions.proAjout(pro);
        });

        if (this.props.location.state === undefined) {
            this.props.history.push('/MesInformations');
            return;
        }
        const { TypePrelevement } = this.props.location.state;
        this.setState({
            TypePrelevementChoisi: TypePrelevement,
        });
    }

    ChangeTypePrelevement({ target }) {
        const champs = target.name;
        const saisie = target.value;
        this.setState({
            [`${champs}`]: saisie,
        });
    }

    ModifState = (NomState, ValeurState) => {
        this.setState({
            [NomState]: ValeurState,
        });
    };

    handleSubmit() {
        if ((this.state.IBAN === '' || this.state.BIC === '') || this.state.idNouveauMandat) return;
        if (this.state.IBAN.length < 14 || this.state.IBAN.length > 34) {
            swal({
                type: 'error',
                title: 'Attention !',
                text: 'Les informations saisies sont vides ou erronées.',
            });
            return;
        }
        // Classe pour l'api
        const SaisieCordBnq = {
            NomBanque: '',
            Siege_Banque: '',
            IBAN_Utilisateur: this.state.IBAN,
            BIC_Utilisateur: this.state.BIC,
            Mode_Prelevement: this.state.TypePrelevementChoisi === 'Manuelle' ? 3 : this.state.ModePrelevement,
            Prlok: this.props.Mandat.PrlOK,
        };
        const bouton = document.getElementById('GenereMandat');
        bouton.innerHTML = '<i class="fas fa-spinner" aria-hidden="true"></i><span> En cours</span>';
        InscriptionPrelevement(SaisieCordBnq).then((response) => {
            if (response.status === HttpStatus.OK) {
                obtenirProprietaire().then((pro) => {
                    this.props.actions.proAjout(pro);
                    this.ModifState('idNouveauMandat', pro.Mandat.MandatInactif.IdMandatInactif);
                    bouton.className = 'btn btn-secondary disabled';
                    bouton.innerHTML = '<span>Mandat généré</span>';
                });
            } else {
                this.ModifState('idNouveauMandat', false);
                swal({
                    type: 'error',
                    title: response.status === HttpStatus.BAD_REQUEST ? 'Attention ! ' : 'Erreur',
                    text: response.data && response.data.Message ? response.data.Message.replace(/["]+/g, '') : "Une erreur s'est produite lors de l'inscription au prélèvement.",
                });
                bouton.innerHTML = '<i class="fa fas fa-check"></i> <span>Valider la saisie</span>';
            }
        });
    }

    creationProcedureSignature() {
        if (!this.state.idNouveauMandat) return;
        if (!this.props.Mandat.MandatInactif.IdMandatInactif || !this.props.Mandat.MandatInactif.Rum) {
            swal('Impossible', 'Veuillez avant tout générer votre mandat.', 'error');
            return;
        }
        creationProcedureSignature(this.props.Mandat.MandatInactif.Rum, this.props.Mandat.MandatInactif.IdMandatInactif, this.props.history);
    }

    render() {
        const {
            ModePrl, Ind, Mandat, SignElecMandatOk,
        } = this.props;

        let classbtn2 = 'btn btn-secondary disabled';
        if (this.state.IBAN !== '' && this.state.BIC !== '' && this.state.IBAN.length > 14 && this.state.IBAN.length < 34) {
            classbtn2 = 'btn btn-primary';
        }

        let classbtn3 = 'btn btn-secondary disabled';
        if (this.state.idNouveauMandat) {
            classbtn3 = 'btn btn-primary';
        }

        return (
            <div>
                <div className="row">
                    <div className="col-12 col-xl-4">
                        <CardCoordonnees PageSaisieIBAN />
                        {!this.state.idNouveauMandat && !Mandat.ProcedureEnCours ? <CardMandatEnCours Mandat={this.props.Mandat} Link={this.props.history} SignElecOk={SignElecMandatOk} /> : null}
                    </div>
                    <div className="col-12 col-xl-8 ">
                        {!Mandat.ProcedureEnCours ?
                            <FormulaireIBAN
                                {...ModePrl}
                                state={this.state}
                                ChangeBIC={this.handleAideSaisieBIC}
                                ChangeModePrelevement={this.handleChangePrelevement}
                                creationProcedureSignature={this.procedureSignature}
                                onSubmit={this.handleSubmit}
                                ModifState={this.ModifState}
                                Mandat={Mandat}
                                Ind={Ind}
                                idNouveauMandat={this.state.idNouveauMandat}
                                SignElecOk={SignElecMandatOk}
                                classbtn2={classbtn2}
                                classbtn3={classbtn3}
                            />
                            : <CardMandatEnCours Mandat={this.props.Mandat} Link={this.props.history} SignElecOk={SignElecMandatOk} />}
                    </div>
                </div>
            </div>
        );
    }
}
PageSaisieIBAN.displayName = 'PageSaisieIBAN';
PageSaisieIBAN.requiredProps = [];

function mapStateToProps({
    ProStore: {
        Pro: { Mandat },
    },
    SynStore: {
        Syn: { ModePrl, Ind, SignElecMandatOk },
    },
}) {
    return {
        ModePrl,
        Ind,
        Mandat,
        SignElecMandatOk,
    };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(ProAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationProps(PageSaisieIBAN));



// WEBPACK FOOTER //
// ./src/components/MesInfos/Prelevement/PageSaisieIBAN.js